export const tree = {
    tabs: {
        timeline: {
            order: 200,
            datatype: [
                10,
                1,
                2
            ],
            tabGroup: 'overview',
            acl: 'g:admin,g:qs',
            parts: [
                'Timeline'
            ]
        }
    }
};
